export const STATE = {
  active: 'is-active',
  inView: 'is-inview',
  disabled: 'is-disabled',
  animate: 'is-animate',
  hide: 'ui-hide',
};
